export default {
    namespaced: true,

    state: {
        bank_statement_id: '',
        from_date: '',
        thru_date: '',
        bank_account_id: '',
    },

    mutations: {
        initialize(state, data) {
            state.bank_statement_id = data.id;
            state.from_date = data.from_date;
            state.thru_date = data.thru_date;
            state.bank_account_id = data.bank_account_id;
            state.currency_opening_balance_in_cents = data.currency_opening_balance_in_cents;
            state.currency_statement_balance_in_cents = data.currency_statement_balance_in_cents;
            state.currency_closing_balance_in_cents = data.currency_closing_balance_in_cents;
            state.currency_book_balance_in_cents = data.currency_book_balance_in_cents;
            state.base_book_balance_in_cents = data.base_book_balance_in_cents;
            state.system_book_balance_in_cents = data.system_book_balance_in_cents;
        },

        updateStatementBalance(state, data) {
            if (data.action == 'increase') {
                state.currency_statement_balance_in_cents += data.amount;
                return;
            }

            state.currency_statement_balance_in_cents -= data.amount;
        },

        updateBookBalance(state, data) {
            state.currency_book_balance_in_cents = data.currency_book_balance_in_cents;
            state.base_book_balance_in_cents = data.base_book_balance_in_cents;
            state.system_book_balance_in_cents = data.system_book_balance_in_cents;
        },

        reset(state) {
            state = {};
        },
    },
};
